export const URL = 'https://backend.unudulmazlar.az/api/v1'
export const MEDIA_URL = 'https://unudulmazlar.az/media/'

export const EXTENSIONS = ["jpg", "jpeg", "png", "gif", "bmp"]



